import PropTypes from 'prop-types';

export default PropTypes.oneOfType([
  PropTypes.shape({
    description: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    usage: PropTypes.string.isRequired,
    picture_name: PropTypes.string.isRequired,
  }),
  PropTypes.shape({
    description: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    included_in: PropTypes.arrayOf(PropTypes.string).isRequired,
    locations: PropTypes.arrayOf(PropTypes.string).isRequired,
    picture_name: PropTypes.string.isRequired,
  }),
]);
